import Router from "next/router";
import Analytics from "analytics";
import amplitudePlugin from "@analytics/amplitude";
import segmentPlugin from "@analytics/segment";
import originalSource from "analytics-plugin-original-source";
import GA4Provider from "./GA4Provider";
import { getCookieValue, monitorCookieValue } from "./cookies";
import { COOKIE_CONSENT_NAME, COOKIE_CONSENT_VALUE } from "../constants";
import { useUpdate } from "../hooks";
import { useEffect } from "react";

const GA_MEASUREMENT_ID = "G-SMLC34WF1D";

const enabled = getCookieValue(COOKIE_CONSENT_NAME) === COOKIE_CONSENT_VALUE;

const tracker = Analytics({
  app: "landing-page",

  plugins: [
    originalSource(),
    amplitudePlugin({
      apiKey: "ded999c2ca9c9e600ad66bd6151c82ac",
      enabled,
      // See options at https://bit.ly/3dRdZnE
      options: {
        serverZone: "eu",
        serverZoneBasedApi: true,
      },
    }),
    GA4Provider({
      id: GA_MEASUREMENT_ID,
      enabled,
      debug_mode: false,
    }),
    segmentPlugin({
      writeKey: "nm9OrXkASnOlFb7jbL6GxQytMcOVlPiZ",
    }),
  ],
});

async function initAnalytics(): Promise<void> {
  await tracker.plugins.enable("ga4");
  await tracker.plugins.enable("amplitude");
  await tracker.plugins.enable("segment");

  logPageViews();
}

function monitorConsent(key: string): void {
  const enabled = isEnabled(key);

  if (enabled) {
    initAnalytics();
  }
}

monitorCookieValue(COOKIE_CONSENT_NAME, monitorConsent);

export function getAnalyticsEnabled(): boolean {
  return isEnabled(getCookieValue(COOKIE_CONSENT_NAME));
}

function isEnabled(value: string) {
  return value === COOKIE_CONSENT_VALUE;
}

export const useAnalyticsEnabled = () => {
  const enabled = getAnalyticsEnabled();
  const update = useUpdate();

  useEffect(() => {
    monitorCookieValue(COOKIE_CONSENT_NAME, () => {
      update();
    });
  });
  return enabled;
};

function logPageView() {
  tracker.page();
}

function logPageViews() {
  logPageView();

  Router.events.on("routeChangeComplete", () => {
    logPageView();
  });
}

export function logEvent(
  action: string,
  label: string,
  category: string
): void {
  tracker.track(action, {
    label,
    category,
  });
}
